"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonPageOGCard = exports.EOGImageType = exports.EOGType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const head_1 = require("../head");
var EOGType;
(function (EOGType) {
    EOGType["Article"] = "article";
    EOGType["Website"] = "website";
    EOGType["Video"] = "video";
})(EOGType || (exports.EOGType = EOGType = {}));
var EOGImageType;
(function (EOGImageType) {
    EOGImageType["JPEG"] = "image/jpeg";
    EOGImageType["PNG"] = "image/png";
    EOGImageType["WEBP"] = "image/webp";
})(EOGImageType || (exports.EOGImageType = EOGImageType = {}));
class CommonPageOGCard extends react_1.Component {
    constructor() {
        super(...arguments);
        this.OGImage = () => {
            return (this.props.ogMediaMetaInfo && ((0, jsx_runtime_1.jsxs)(head_1.DynamicHead, { children: [(0, jsx_runtime_1.jsx)("meta", { property: "og:image:type", content: this.props.ogMediaMetaInfo.type || this.ogImageDefaultType }), (0, jsx_runtime_1.jsx)("meta", { property: "og:image", content: this.props.ogMediaMetaInfo.url }), (0, jsx_runtime_1.jsx)("meta", { property: "og:image:width", content: String(this.props.ogMediaMetaInfo.width || CommonPageOGCard.DEFAULT_IMAGE_WIDTH) }), (0, jsx_runtime_1.jsx)("meta", { property: "og:image:height", content: String(this.props.ogMediaMetaInfo.height || CommonPageOGCard.DEFAULT_IMAGE_HEIGHT) })] })));
        };
        this.OGVideo = () => {
            return (this.props.ogMediaMetaInfo && ((0, jsx_runtime_1.jsxs)(head_1.DynamicHead, { children: [(0, jsx_runtime_1.jsx)("meta", { property: "og:video:type", content: "video/mp4" }), (0, jsx_runtime_1.jsx)("meta", { property: "og:image", content: this.props.ogMediaMetaInfo.coverUrl }), (0, jsx_runtime_1.jsx)("meta", { property: "og:video", content: this.props.ogMediaMetaInfo.videoUrl }), (0, jsx_runtime_1.jsx)("meta", { property: "og:video:width", content: String(this.props.ogMediaMetaInfo.width) }), (0, jsx_runtime_1.jsx)("meta", { property: "og:video:height", content: String(this.props.ogMediaMetaInfo.height) }), (0, jsx_runtime_1.jsx)("meta", { property: "og:video:duration", content: String(this.props.ogMediaMetaInfo.duration) })] })));
        };
    }
    get ogImageDefaultType() {
        const ogMediaMetaInfo = this.props.ogMediaMetaInfo;
        if (!ogMediaMetaInfo) {
            return EOGImageType.JPEG;
        }
        if (ogMediaMetaInfo.url.includes('.webp')) {
            return EOGImageType.WEBP;
        }
        if (ogMediaMetaInfo.url.includes('.png')) {
            return EOGImageType.PNG;
        }
        return EOGImageType.JPEG;
    }
    render() {
        const { OGImage, OGVideo } = this;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(head_1.DynamicHead, { children: [(0, jsx_runtime_1.jsx)("meta", { property: "og:site_name", content: "Lemon8" }), (0, jsx_runtime_1.jsx)("meta", { property: "og:url", content: this.props.ogUrl }), (0, jsx_runtime_1.jsx)("meta", { property: "og:type", content: this.props.ogType }), (0, jsx_runtime_1.jsx)("meta", { property: "og:title", content: this.props.ogTitle }), (0, jsx_runtime_1.jsx)("meta", { property: "og:description", content: this.props.ogDescription })] }), this.props.ogType === EOGType.Video ? (0, jsx_runtime_1.jsx)(OGVideo, {}) : (0, jsx_runtime_1.jsx)(OGImage, {})] }));
    }
}
exports.CommonPageOGCard = CommonPageOGCard;
CommonPageOGCard.DEFAULT_IMAGE_WIDTH = 360;
CommonPageOGCard.DEFAULT_IMAGE_HEIGHT = 360;
